/*eslint-disable*/
import { useState, useEffect } from "react";
import styled from '@emotion/styled';
import Moment from 'react-moment';


import {
    Badge,
    Card,
    CardImg,
    CardTitle,
} from "reactstrap";

import UserAvatar from '../../../../assets/images/public/avatar1.svg';


const ChangelogDetailsPaneWrapper = styled.div`
    padding-left: 20px;

    .__label {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #525866;
        margin-bottom: 5px;
    };

    .__tags {
        margin-top: 20px;
        margin-bottom: 0px;

        .__tag {
            vertical-align: top;
            display: inline-block;
            font-size: 13px;
            padding: 4px 10px;
            text-transform: capitalize;
            font-weight: 500;

            &.new {
                color: #23392A !important;
                background-color: #DBEDDB !important;
            }

            &.improvement {
                color: #3B2649 !important;
                background-color: #E2D5DF !important;
            }

            &.fixes {
                color: #581A18 !important;
                background-color: #FCE3DC !important;
            }
        }

        &.hide {
            display: none;
        }
    }

    .__name, .__last-updated, .__created-on {
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        color: #0E121B;
        margin-left: 5px;
    }
    .__divider {
        border-bottom: 1px dashed #E2E4E9;
        margin-top: 20px;
        margin-bottom: 20px;
        border-top: none;
    }

`

const ChangelogDetailsPane = ({
    changelogItem,
    allChangelogTags,
    SmileyReactions,
}) => {
    const {
        author,
        tags,
        updated_at,
        created_at,
    } = changelogItem;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <ChangelogDetailsPaneWrapper>
            <p className="__label">Tags</p>
            <div className="__tags">
                {tags.map((tag, index) => (
                    <Badge
                        key={index}
                        className={`__tag ${allChangelogTags.find(t => t.id === tag).id}`}
                        style={{
                            color: '#fff',
                        }}
                        pill
                    >
                        {tag}
                    </Badge>
                ))}
            </div>
            <br />
            <p className="__label">Author</p>
            <div className="__author">
                <img src={UserAvatar} alt="avatar" />
                <span className="__name">{author.name}</span>
            </div>

            <br />

            <p className="__label">Last updated on</p>
            <div className="__last-updated">
                <Moment format="ll">{updated_at['$date']}</Moment>
            </div>

            <br />
            <p className="__label">Created on</p>
            <div className="__created-on">
                <Moment format="ll">{created_at['$date']}</Moment>
            </div>

            <hr className="__divider" />

            <p className="__label">Share your feedback</p>
            <div className="__description">
                {
                    changelogItem.settings.reactions && (
                        <div style={{ borderTop: 0 }}>
                            <SmileyReactions changelog={changelogItem} />
                        </div>
                    )
                }
            </div>

        </ChangelogDetailsPaneWrapper>
    );
};

export default ChangelogDetailsPane;
